<!--
 * Created by JackCui on 2021/12/1
 -->
<script>
import {cloneDeep, eq} from 'lodash-es'
import {FIELD_TYPE} from 'fe-coms-share/paas/constants'
import processRelate from 'fe-coms-share/paas/business/process-relate'
import defaultPropsHandle from './field-props'

export default {
  name: 'field-render',
  props: {
    changeRequired: Function,
    node: Object,
    rowIndex: Number,
    groupProp: String,
    row: Object,
    forceFollow: Boolean
    // hideName: Boolean //  列表只有一项隐藏label
  },
  inject: ['formData', 'subData', 'pageType', 'syForm', 'isFieldGroup'],
  watch: {
    'newProps.required': {
      immediate: true,
      deep: true,
      handler (value) {
        if (this.node.rules) {
          let requiredIdx = this.node.rules.findIndex(v => v.hasOwnProperty('required'))

          if (requiredIdx < 0) {
            requiredIdx = 0
          }
          this.node.rules.forEach(v => {
            this.$set(v, 'required', value)
          })
        }
        this.changeRequired && this.changeRequired(this.node.apiName, value)
      }
    },
    inputValue: {
      immediate: false,
      handler (val) {
        // TODO 优化watch监听 改为动态监听 没有的字段不会watch
        this.handlerTrigger(val)
      }
    }
  },
  computed: {
    // // TODO 列表只有一项隐藏label
    // hideLabel () {
    //   if (this.isTable) {
    //     return this.hideName
    //   }
    //   if (isBoolean(this.newProps?.hideLabel)) {
    //     return this.newProps.hideLabel
    //   }
    // },
    id () {
      return this.curFormData?.['aPaaS_SequenceId']
    },
    // 是否为从对象
    isTable () {
      return typeof this.rowIndex === 'number'
    },
    // 组件name
    fieldComponentName () {
      return this.node.fieldComponentName
    },
    fieldShow () {
      return !this.newProps.hasOwnProperty('pageShow') || this.newProps.pageShow
    },
    newProps () {
      const {props, propsFn, type} = this.node
      const defaultProps = defaultPropsHandle(type, this.styleType)
      // 需要拷贝
      // 因为每行propsFn返回值不一样 不能直接修改node.props
      let _props = Object.assign({}, props, {
        ...defaultProps,
        id: this.id,
        size: this.styleType,
        row: this.row,
        rowIndex: this.rowIndex
      })
      if (typeof _props.width === 'number' && !_props.textShow) _props.width += 'px'
      if (this.isFieldGroup && _props.textShow) _props.width = 'auto'
      if (typeof propsFn === 'function') {
        return Object.assign(
          _props,
          propsFn.call(this, {
            field: this.node,
            formData: this.formData,
            row: this.curFormData,
            rowIndex: this.rowIndex
          })
        )
      }

      // 必填字段不可隐藏
      if (_props.required) {
        // 更新字段本身状态
        props.pageShow = true
        // 更新当前展示状态
        _props.pageShow = true
      }

      return _props
    },
    newEvents () {
      const __ = this.node.event
      const events = {}

      for (let v in __) {
        if (!__.hasOwnProperty(v)) {
          continue
        }

        events[v] = (...arg) => {
          return __[v].call(this,
            arg.length === 1
              ? arg[0]
              : arg,
            {
              field: this.node,
              formData: this.formData,
              row: this.curFormData,
              rowIndex: this.rowIndex
            }
          )
        }
      }
      return events
    },
    rules () {
      const {formData, subData, node, row, rowIndex} = this
      // TODO 纯文本不去掉规则
      // if (newProps?.isPureText) {
      //   return []
      // }
      let {rules = [], ruleFn} = node
      let _rules = cloneDeep(rules)
      if (typeof ruleFn === 'function') {
        _rules = _rules.concat(ruleFn({
          newProps: this.newProps,
          field: node,
          formData: formData,
          subData,
          row,
          rowIndex
        }) || [])
      }
      return _rules.map(v => {
        if (typeof v === 'function') {
          return v({
            newProps: this.newProps,
            field: node,
            formData: formData,
            subData,
            row,
            rowIndex
          })
        }
        return v
      })
    },
    // 对象字符串list
    objectStringList () {
      return this.node.apiName?.split('.') || []
    },
    multipartyBindData () {
      const list = this.objectStringList
      let obj = this.curFormData
      for (let i = 0; i < list.length - 1; i++) {
        obj = obj[list[i]]
      }
      return obj
    },
    inputValue: {
      get () {
        const list = this.objectStringList
        return this.multipartyBindData?.[list[list.length - 1]]
      },
      set (val) {
        const list = this.objectStringList
        this.$set(this.multipartyBindData, list[list.length - 1], val)
      }
    },
    curFormData () {
      return this.row || this.formData
    },
    prop () {
      const {targetApiName, parentKey} = this.node
      const {rowIndex, groupProp} = this
      if (typeof rowIndex !== 'number') {
        return targetApiName
      }
      if (!parentKey) {
        return `${rowIndex}.${targetApiName}`
      }
      if (groupProp) {
        return `${parentKey}.${groupProp}.${rowIndex}.${targetApiName}`
      }
      return `${parentKey}.${rowIndex}.${targetApiName}`
    },
    styleType () {
      return this.isTable ? 'mini' : 'small'
    },
    className () {
      const {isPureText, className = ''} = this.newProps || {}
      return isPureText ? `is-pure-text field field-${this.styleType} field-${this.node.pageType} ${className}` : `field field-${this.styleType} field-${this.node.pageType} ${className}`
    },
    span () {
      const {fieldConf, props} = this.node
      const spanMap = {1: '0'}
      return spanMap[fieldConf?.supportBanner] || props.span
    },
    newFollow () {
      if (this.node.props.hasOwnProperty('follow')) return this.node.props.follow
      // if (this.node.pageType === 'layout_type_detail' && this.syForm?.computedPosition !== 'top') return true
      return this.forceFollow || (this.node.follow && typeof this.rowIndex === 'number') || (this.node.follow && this.isFieldGroup)
    }
  },
  methods: {
    handlerTrigger (val) {
      const _parentNode = processRelate.getNode({
        objectApiName: this.node.objectApiName,
        fieldApiName: this.node.apiName,
        rowId: this.row?.['aPaaS_SequenceId']
      })

      // 排除掉相同的更新 相同值 不触发更新
      if (eq(val, _parentNode.value)) {
        return
      }

      // 触发节点的递归更新
      processRelate.triggerNodes({..._parentNode, value: val})
      // 引用字段编辑后也可以更新
      if (_parentNode.fieldType !== FIELD_TYPE.QUOTE) {
        processRelate.cancelNode(_parentNode)
      }
      console.log(processRelate.nodeMap)
    },
    contentSlots (h) {
      /* eslint-disable */
      const Component = this.fieldComponentName
      const contentSlots = this.slotsHandle(h, 'content')
      return this.getSlotsFn('content')
        ? contentSlots
        : <Component
          v-model={this.inputValue}
          props={{...this.newProps}}
          attrs={{...this.newProps}}
          on={{...this.newEvents}}
        />
    },
    getSlotsFn (position) {
      const {slots} = this.node
      return slots?.[position]
    },
    slotsHandle (h, position) {
      const Fn = this.getSlotsFn(position)
      if (Fn) {
        return Fn(h, {
          field: this.node,
          formData: this.formData,
          row: this.row,
          rowIndex: this.rowIndex
        })
      }
      return null
    }
  },
  render (h) {
    if (!this.fieldShow) {
      return null
    }
    const {styleType, rules, prop, newFollow, className} = this
    const contentSlots = this.contentSlots(h)
    const temp = [
      this.slotsHandle(h, 'before'),
      <div class={className}>{contentSlots}</div>,
      this.slotsHandle(h, 'after')
    ]
    return (
      this.getSlotsFn('content') && !contentSlots
        ? null
        : <sy-form-item
          key={prop}
          props={{
            ...this.newProps,
            prop,
            rules,
            styleType,
            follow: newFollow,
            span: this.span,
            pageType: this.pageType
          }}
        >{temp}</sy-form-item>
    )
  }
}
</script>
<style scoped lang='scss'>
::v-deep {
  // .is-error {
  //   input.el-input__inner {
  //     border-color: red !important;
  //   }
  // }

  // input.el-input__inner::-webkit-input-placeholder {
  //   // color: #BFC7E0 !important;
  // }

  // input.el-input__inner {
  //   border-color: #EDEFF4 !important;
  //   border-radius: 2px;
  // }

  .field {
    color: #2E3656;
    word-break: break-all;

    &.field-mini.is-pure-text {
      padding-top: 8px;
      font-size: 12px;
    }

    &.is-pure-text {
      padding-top: 6px;
      font-size: 14px;
    }

    &.field-layout_type_detail {
      // padding-top: 0;
    }

  }

  .el-select {
    width: 100%;
  }
}

::v-deep .sy-accessory-mini {
  overflow: visible;
}

::v-deep .edit-address-wrap {
  padding-top: 6px;
}

::v-deep .file-empty {
  padding-top: 8px;
  display: inline-block;
}

// 上下结构覆盖padding样式
.sy-form-item--top {
  ::v-deep .field.is-pure-text {
    padding-top: 0;
  }
}
</style>
